<template>
<div>
    <a-card :title="c_title">
        <v-gobackbutton v-show="isGuide != 'process'" slot="extra">返回</v-gobackbutton>

    <a-form-model
        :model="modalState"
        ref="ruleForm"
        :rules="rules"
        :layout="formItemLayout"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
    >
        <a-form-model-item ref="syscode" label="所属系统" prop="syscode">
            <a-select v-if="is_vue_task"  v-model="modalState.syscode" show-search placeholder="请选择">
                <a-select-option v-for="(item,index) in syslist" :key="index" v-model="item.syscode">
                {{item.sysname + '【' + item.syscode + '】'}}
                </a-select-option>
            </a-select>
            <span class="form_span" v-else>{{modalState.syscode}}</span>
        </a-form-model-item>
        <a-form-model-item ref="appcode" label="应用编码" prop="appcode">
            <a-input
                v-if="is_vue_task"
                v-model="modalState.appcode"
                    @blur="
                    () => {
                        $refs.appcode.onFieldBlur();
                    }
                    "
            />
            <span v-else>{{modalState.appcode}}</span>
        </a-form-model-item>
        <a-form-model-item ref="appenname" label="应用英文简称" prop="appenname">
            <a-input
            v-if="is_vue_task"
                v-model="modalState.appenname"
                    @blur="
                    () => {
                        $refs.appenname.onFieldBlur();
                    }
                    "
            />
            <span class="form_span" v-else>{{modalState.appenname}}</span>

        </a-form-model-item>
        <a-form-model-item ref="appname" label="应用中文简称" prop="appname">
            <a-input
            v-if="is_vue_task"
                v-model="modalState.appname"
                    @blur="
                    () => {
                        $refs.appname.onFieldBlur();
                    }
                    "
            />
            <span class="form_span" v-else>{{modalState.appname}}</span>

        </a-form-model-item>
        <a-form-model-item ref="appsecretkey" label="应用秘钥" prop="appsecretkey">

            <a-input-search
                v-if="is_vue_task"
                v-model="modalState.appsecretkey"
                enter-button="生成秘钥"
                @search="uuid"
                    @blur="
                    () => {
                        $refs.appname.onFieldBlur();
                    }
                    "
            />
            <span class="form_span" v-else>{{modalState.appsecretkey}}</span>
        </a-form-model-item>
        <a-form-model-item ref="thdetectflagBoolen" label="是否开启线程池探测" prop="thdetectflagBoolen">
            <a-switch v-model="thdetectflagBoolen" />
        </a-form-model-item>

        <a-form-model-item label="备注" ref="remark" prop="remark" :labelCol="labelCol"
            :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
            <a-input v-if="is_vue_task"  v-model="modalState.remark" type="textarea"
                        @blur="() => {
                        $refs.remark.onFieldBlur();
                    }
                    " />
            <span class="form_span" v-else>{{modalState.remark}}</span>

        </a-form-model-item>
         <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }" v-show="is_vue_task">
            <a-button type="primary" @click="handleOk">
                保存
            </a-button>
            <a-button style="margin-left: 10px;" @click="handleCancel">
                取消
            </a-button>
        </a-form-model-item>
        <div v-if="!isAddApp">
        <a-divider>应用关联</a-divider>
        <a-form-model-item label="所属域名" prop="appDomains">
            <a-button type="primary" @click="handleNewDomain" v-show="is_vue_task" style="float:right;">绑定域名</a-button>
            <div class="domain_container">
                <a-tag v-for="(item,index) in appDomains" :key="index" color="#1890ff" class="domain_tag_c">
                    {{item.domain}}

                    <a-popconfirm title="确定需要删除该域名？"  @confirm="() => handleDomainDelete(item)"  v-if="is_vue_task">
                        <a-icon type="close" style="font-size:16px;"/>
                    </a-popconfirm>
                </a-tag>

                <p v-if="appDomains.length == 0" style="text-align:center;font-weight:bold;">--暂无域名--</p>
            </div>
            <DomainSelecter :modalState="modalStateDomain" @onModalHide="onDomainselecterHide"></DomainSelecter>

        </a-form-model-item>

        <a-form-model-item label="所属servicekey" prop="appsecretkey" v-show="true">
            <a-input-search placeholder="输入servicekey"  allow-clear style="width: 200px" @search="onSearch" />
            <a-button type="primary" @click="handleServicekeyModal" style="float:right;"  v-show="is_vue_task" >绑定服务</a-button>
            <ServiceKeySelecter :modalState="modalStateServicekey" @onModalHide="onServiceKeyselecterHide"></ServiceKeySelecter>

            <!-- 系统列表 -->
            <a-table :columns="columns" :data-source="appServicekey" :pagination="false"
                :loading="tLoading" rowKey="id">
                <template slot="operation" slot-scope="text, record">
                    <div class="editable-row-operations">
                        <span style="margin-left:15px;">
                            <a-popconfirm @confirm="() => onAppServiceKeyDelete(record)" v-if="is_vue_task">
                                <template slot="title">
                                    <p>{{ '确认将【' + record.servicekey+ '】删除？' }}</p>
                                </template>
                                <a>删除</a>
                            </a-popconfirm>
                        </span>
                    </div>
                </template>

                <template slot="servicekeyt" slot-scope="text, record">
                    <span>
                        <router-link
                            :to="{
                            path:'/servicekey/list',
                            query: {
                                keyword: record.servicekey,
                            }
                        }"
                        >{{text}}</router-link>
                    </span>
                </template>

            </a-table>

            <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

        </a-form-model-item>
</div>


        <!-- <a-form-model-item label="备注" prop="remark" >
            <a-input v-model="modalState.remark" type="textarea" />
        </a-form-model-item> -->


    </a-form-model>
    </a-card>

</div>

</template>
<script>
import ServiceKeySelecter from '@/components/ServiceKeySelecter';
import DomainSelecter from '@/components/DomainSelecter';
let pagination={
    total:0,
    pageSize:0,
    page:1,
}
const columns = [
    {
        title: "序号",
        width: 30,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '应用编码',
        dataIndex: 'appcode',
        align: 'center',
        width:80,
    },
    {
        title: '服务Key',
        dataIndex: 'servicekey',
        align: 'center',
        width:250,
        scopedSlots: { customRender: 'servicekeyt' },
    },
    // {
    //     title: '备注',
    //     dataIndex: 'remark',
    //     align: 'center',
    //     width:50,
    // },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width:80,
        scopedSlots: { customRender: 'operation' },
    },
];

const m_title = {
    'addapp':'新增应用',
    'detailapp':'应用详情',
    'editapp':'编辑应用',
};
export default {
    data() {
        return {

            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            is_vue_task:true,
            rules: {
                syscode: [
                    { required: true, message: '请输入系统编码', trigger: 'blur' },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],
                appcode: [
                    { required: true, message: '请输入应用编码', trigger: 'blur' ,},
                    { max: 20, message: '不能超过20位', trigger: 'blur' },

                ],
                appenname:[
                    { required: true, message: '请输入应用英文简称', trigger: 'blur' },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],
                appname:[
                    { required: true, message: '请输入应用中文简称', trigger: 'blur' },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],
                remark:[
                    { max: 500, message: '不能超过500位', trigger: 'blur' },
                ],
                appsecretkey:[
                    { max: 32, message: '不能超过32位', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            syslist:[],
            c_title:'编辑应用',
            modalState:{
                id:'',
                syscode:'',
                appcode:'',
                appenname:'',
                appname:'',
                remark:'',
                appsecretkey:'',
                thdetectflag:'N'
            },
            thdetectflagBoolen:false,
            appServicekey:undefined,
            appDomains:[

            ],
            tLoading:false,
            columns:columns,
            pagination:pagination,
            searchKey:'',
            modalStateServicekey:{
                isShow:false,
                rowsType:'checkbox',
                domain:'',
                selectkeys:[],
            },
            modalStateDomain:{
                isShow:false,
                rowsType:'checkbox',
                domain:'',
                filterDomain:[],
            },
            isAddApp:false,
            paramsAction:''
        };
    },
    props:{
        isGuide:String
    },
    methods: {
        //所属域名删除
        handleDomainDelete(domainItem){
            this.$store.dispatch({
                type: "app/deleteAppDomainBind",
                params:{
                    id:domainItem.id,
                    urlparams:false
                }
            }).then((res)=>{
                if(res.status == '200'){
                    this.getAppDomain();
                }
            });
        },
        getAppDomain(){
            this.$store.dispatch({
                type: "app/getAppDomainBind",
                params:{
                    urlparams:false,
                    appcode:this.modalState.appcode,
                }
            }).then((res)=>{
                console.log(res)
                if(res.status == 200){
                    this.appDomains = res.data.data;
                    this.modalStateDomain.filterDomain = [];
                    this.appDomains.forEach(element => {
                        this.modalStateDomain.filterDomain.push(element.domain)
                    });
                }
            });
        },
        handleNewDomain(){
            this.modalStateDomain.isShow = true;
        },
        onDomainselecterHide(result){
            //添加domain
            if(result == undefined){
                this.modalStateDomain.isShow = false;
                return
            }
            //调用添加app domain关联接口
            let insertData = [];
            result.forEach(element => {
                insertData.push({
                    appcode:this.modalState.appcode,
                    domain:element.domain
                })
            });
            this.$store.dispatch({
                type: "app/addAppDomainBind",
                params:{
                    insertData :JSON.stringify(insertData),
                    urlparams:false
                }
            }).then(()=>{
                this.getAppDomain()
                this.modalStateDomain.isShow = false;
            });
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.modalState.thdetectflag = this.thdetectflagBoolen ? 'Y' : 'N'
                    console.log(this.modalState);
                    
                    if(this.paramsAction == "editapp"){
                        //编辑
                        this.$store
                            .dispatch({
                                type: "app/editApp",
                                params: this.modalState
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel()
                                    this.confirmLoading = false;
                                }
                            });
                    }
                    else{
                        //新增
                        this.$store
                            .dispatch({
                                type: "app/addApp",
                                params: this.modalState
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    this.handleCancel()
                                }
                                this.confirmLoading = false;


                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        uuid() {
            var s = [];
            var hexDigits = '0123456789abcdef';
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = '4';
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = '';

            this.uuidA = s.join('');
            // console.log(s.join(''), 's.join("")');
            this.modalState.appsecretkey = this.uuidA;
        },
        handleCancel() {
            this.$router.back(-1);
        },

        getAppServicekey(){
            this.tLoading = true;
            this.$store.dispatch({
                type: "app/queryAppServicekeyBind",
                params:{
                    urlparams:false,
                    appcode:this.modalState.appcode,
                    servicekey:this.searchKey,
                    ...pagination
                }
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                this.appServicekey = result.list;
                this.pagination.total = result.totalRecords;
                this.pagination.pageSize = result.pageSize;
                this.pagination.current = result.page;
            });
        },

        onAppServiceKeyDelete(record){
            this.$store.dispatch({
                type: "app/deleteAppServicekeyBind",
                params:{
                    id:record.id,
                    urlparams:false
                }
            }).then((res)=>{
                if(res.status == '200'){
                    this.getAppServicekey();
                }
            });
        },
        handlePageChange(t){
            this.pagination.page = t;
            this.getAppServicekey();
        },
        onSearch(v){
            this.searchKey = v;
            this.getAppServicekey()
        },
        handleServicekeyModal(){
            let that = this;
            //获取当前应用对应所有servicekey作为已选择项
            this.$store.dispatch({
                type: "app/getAllAppServicekeyBind",
                params:{
                    appcode:that.modalState.appcode,
                    urlparams:false
                }
            }).then((res)=>{
                let keydata= res.data.data;

                that.modalStateServicekey.selectkeys = [];
                keydata.forEach(element => {
                    that.modalStateServicekey.selectkeys.push(element.servicekey)
                });
                this.modalStateServicekey.isShow = true;
            });

        },
        onServiceKeyselecterHide(result){
            if(result == undefined){
                this.modalStateServicekey.isShow = false;
                return
            }
            //调用添加app servicekey关联接口
            let insertData = [];
            result.forEach(element => {
                insertData.push({
                    appcode:this.modalState.appcode,
                    servicekey:element.servicekey
                })
            });
            this.$store.dispatch({
                type: "app/addAppServicekeyBind",
                params:{
                    insertData :JSON.stringify(insertData),
                    urlparams:false
                }
            }).then(()=>{
                this.getAppServicekey();
            });
            this.modalStateServicekey.isShow = false;

        },
    },
    mounted() {

        //页面加载完成-接口获取系统列表
        this.$store.dispatch({
            type: "sys/sysSelecter",
        }).then((res)=>{
            this.syslist = res.data.data;
        });
        const { query, params} = this.$route;
        if(this.isGuide == "process"){
            params.action = "addapp";
        }
        this.c_title = m_title[params.action];
        this.is_vue_task = params.action != 'detailapp';
        this.paramsAction = params.action;
        if(params.action != 'addapp'){
            //获取app详情
            this.$store.dispatch({
                type: "app/getAppItem",
                params:query
            }).then((res)=>{
                this.modalState = res.data.data;
                this.thdetectflagBoolen = res.data.data.thdetectflag == 'Y';
                this.getAppServicekey();
                this.getAppDomain();
            });
            this.isAddApp = false;
        }
        else{
            this.isAddApp = true
        }
    },
    components:{DomainSelecter,ServiceKeySelecter},

};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.domain_tag_c{
    font-size: 16px;
    padding: 4px 12px;
}
.domain_container{
    width: 100%;
    height: auto;
    float: left;
    border:1px solid lightgray;
    margin-top: 10px;
    padding: 10px;
}
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
</style>
